export const typeSafeObjectEntries = (obj) => Object.entries(obj);
export const typeSafeObjectFromEntries = (entries) => Object.fromEntries(entries);
export const camelToKebab = (str) => str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
